export enum StatesEnum {
    Active = 1,
    Inactive = 2
}
